import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INDEX_USER_PASSWORD } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  /**
   * Get all verified users
   */
  index(keyword?: string, page?: number, limit?: number) {
    const payload: any = {
      pw: INDEX_USER_PASSWORD,
      keyword,
      page,
      limit
    };
    
    return this.http.post<any>('api_endpoint' + '/user/index-verified', payload);
  }

  indexV2(keyword?: string, page?: number, limit?: number) {
    const payload: any = {
      pw: INDEX_USER_PASSWORD,
      keyword,
      page,
      limit
    };
    
    return this.http.post<any>('api_endpoint' + '/user/v2/index-verified', payload);
  }

  /**
   * Create player
   */
  create(user) {
    return this.http.post<any>('api_endpoint' + '/user/create', user);
  }

  /**
   * UPDATE my profile
   */
  update(userId, user) {
    return this.http.put<any>('api_endpoint' + `/user/${userId}`, user);
  }

  /**
   * Crate my profile
   */
  myProfile() {
    return this.http.get<any>('api_endpoint' + '/user/my-profile');
  }

  /**
   * Get Auth User
   */
  getAuthUser() {
    return this.http.get<any>('api_endpoint' + '/user/getAuthUser');
  }

  /**
   * Get Cognito User
   */
  getCognitoUser() {
    return this.http.get<any>('api_endpoint' + '/v2/auth/getCognitoUser');
  }

  /**
   * Crate my profile
   */
  show(userId) {
    return this.http.get<any>('api_endpoint' + '/user/' + userId);
  }

  /**
   * UPDATE my profile
   */
  updateMyProfile(user) {
    return this.http.put<any>('api_endpoint' + '/user/my-profile', user);
  }

  /**
   * Remove my player account
   */
  deleteUser(userId) {
    return this.http.put<any>('api_endpoint' + '/user/remove-user', {
      userId: userId,
    });
  }

  /**
   * Delete account
   */
  deleteAccount() {
    return this.http.delete<any>('api_endpoint' + '/user/delete-account');
  }

  /**
   * Add  jersey number
   */
  addJerseyNumber(teamId: string, playerId: string, jerseyNumber: number) {
    return this.http.patch<any>('api_endpoint' + `/team/${teamId}/update-jersey/${playerId}`, {jerseyNumber});
  }

  sendOTPEmail(email: string, phone: string) {
    return this.http.post<any>('api_endpoint' + '/v2/auth/send-email-verification-code', { email, phone });
  }

  verifyOTP(email: string, otp: string, phone: string, password: string) {
    return this.http.post<any>('api_endpoint' + '/v2/auth/verify-email', { email, code: otp, phone, password } );
  }
}
